import Flickity from "flickity";

const QuoteSlider = (slides) => {

    // Wrapper for the slider
    var sliderWrapper = document.querySelector('.quote-slider__slides');
    
    // Count Individual Slide(s)
    var slideCount = sliderWrapper.querySelectorAll('.quote-slider__slide');

    // Slides great than 1
    var hasMultipleSlides = slideCount.length > 1;

    if ( hasMultipleSlides ) {

        var flkty = new Flickity(slides, {
            draggable : true, 
            fade : true, 
            wrapAround : false, 
            prevNextButtons : true,
            autoPlay : false,
            pauseAutoPlayOnHover: true,
            pageDots: false
        });

    }


}

export default QuoteSlider;
